import { Tooltip, TooltipContent, TooltipTrigger } from "./tooltip";

interface ConsistentTooltipProps {
  children: React.ReactNode;
  content: string;
  trigger: React.ReactNode;
}

export const ConsistentTooltip = ({
  children: _children,
  content,
  trigger,
}: ConsistentTooltipProps) => (
  <Tooltip>
    <TooltipTrigger asChild>{trigger}</TooltipTrigger>
    <TooltipContent className="bg-gray-800 text-white border-gray-600 max-w-[300px]">
      {content}
    </TooltipContent>
  </Tooltip>
);
